import { render, staticRenderFns } from "./tabsCustom-intervies.vue?vue&type=template&id=2a835ca8&scoped=true&"
import script from "./tabsCustom-intervies.vue?vue&type=script&lang=js&"
export * from "./tabsCustom-intervies.vue?vue&type=script&lang=js&"
import style0 from "./tabsCustom-intervies.vue?vue&type=style&index=0&id=2a835ca8&prod&lang=scss&scoped=true&"
import style1 from "./tabsCustom-intervies.vue?vue&type=style&index=1&id=2a835ca8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a835ca8",
  null
  
)

export default component.exports